import api from '../utils/api'

// Product Service
const productService = {
    // Get all products
    async getAllProducts() {
        try {
            const response = await api.get('/api/products')
            return Array.isArray(response.data.data) ? response.data.data : []
        } catch (error) {
            console.error('Error fetching products:', error)
            return []
        }
    },

    // Get product by ID
    async getProductById(id) {
        try {
            const response = await api.get(`/api/products/${id}`)
            return response.data.data
        } catch (error) {
            console.error('Error fetching product:', error)
            throw error
        }
    },

        // Get product by ID
        async getProductByBarcode(barcode) {
            try {
                const response = await api.get(`/api/products/barcode/${barcode}`)
                return response.data.data
            } catch (error) {
                console.error('Error fetching product:', error)
                throw error
            }
        },

    // Create new product
    async createProduct(productData) {
        try {
            const response = await api.post('/api/products', productData)
            return response.data
        } catch (error) {
            console.error('Error creating product:', error)
            throw error
        }
    },

    // Update product
    async updateProduct(id, productData) {
        try {
            const response = await api.put(`/api/products/${id}`, productData)
            return response.data
        } catch (error) {
            console.error('Error updating product:', error)
            throw error
        }
    },

    // Delete product
    async deleteProduct(id) {
        try {
            const response = await api.delete(`/api/products/${id}`)
            return response.data
        } catch (error) {
            console.error('Error deleting product:', error)
            throw error
        }
    },

    // Search products
    async searchProducts(query) {
        try {
            const response = await api.get(`/api/products/search/${encodeURIComponent(query)}`)
            return Array.isArray(response.data.data) ? response.data.data : []
        } catch (error) {
            console.error('Error searching products:', error)
            return []
        }
    },
    // Update product stock
    async updateStock(id, quantity, type, reason) {
        try {
            const response = await api.put(`/api/products/${id}/stock`, {
                quantity,
                type,
                reason
            })
            return response.data
        } catch (error) {
            console.error('Error updating stock:', error)
            throw error
        }
    },
    // Get products by category
    async getProductsByCategory(category) {
        try {
            const response = await api.get(`/api/products/category/${category}`)
            return Array.isArray(response.data.data) ? response.data.data : []
        } catch (error) {
            console.error('Error fetching products by category:', error)
            return []
        }
    }
    ,
    async getFamilies() {
        const response = await api.get('/api/products/families')
        return response.data.data || []
    },
    async createFamily(data) {
        return (await api.post('/api/products/families', data)).data
    },
    async updateFamily(id, data) {
        return (await api.put(`/api/products/families/${id}`, data)).data
    },
    async getFamilyVariants(familyId) {
        return (await api.get(`/api/products/families/${familyId}/variants`)).data.data || []
    },
    async createVariant(familyId, data) {
        return (await api.post(`/api/products/families/${familyId}/variants`, data)).data
    },
    async getProductUnits(productId) {
        return (await api.get(`/api/products/${productId}/units`)).data.data || []
    },
    async updateProductUnits(productId, units) {
        return (await api.put(`/api/products/${productId}/units`, { units })).data
    }
}



// Named exports for easier import
export const getProducts = (page = 1, limit = 100) => {
    // For quotes page, we need a function that accepts pagination parameters
    // but returns all products in the format expected by the API
    return productService.getAllProducts()
        .then(data => ({
            success: true,
            data: data
        }))
        .catch(error => ({
            success: false,
            data: []
        }))
}

export const getProductByBarcode = productService.getProductByBarcode
export const getProductById = productService.getProductById
export const createProduct = productService.createProduct
export const updateProduct = productService.updateProduct
export const deleteProduct = productService.deleteProduct
export const updateStock = productService.updateStock

export default productService
